/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dice_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online dice roller. Roll one or many dice with 4, 6, 8, 10, 12 or 20 sides and see each result plus the total. Great for games and tabletop RPGs.`)
};

const es_dice_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanzador de dados online gratuito. Tira uno o varios dados de 4, 6, 8, 10, 12 o 20 caras y ve cada resultado más el total. Perfecto para juegos de mesa y rol.`)
};

const de_dice_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Online-Würfel-Generator. Würfle mit einem oder mehreren Würfeln mit 4, 6, 8, 10, 12 oder 20 Seiten und sieh jedes Ergebnis plus die Summe. Ideal für Brettspiele und Pen-&-Paper-Rollenspiele.`)
};

const nl_dice_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online dobbelstenen gooien. Gooi met één of meerdere dobbelstenen met 4, 6, 8, 10, 12 of 20 zijden en bekijk elk resultaat plus het totaal. Ideaal voor spellen en tabletop RPG's.`)
};

const fr_dice_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanceur de dés en ligne gratuit. Lancez un ou plusieurs dés à 4, 6, 8, 10, 12 ou 20 faces et voyez chaque résultat ainsi que le total. Idéal pour les jeux et jeux de rôle sur table.`)
};

const it_dice_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lanciadadi online gratuito. Lancia uno o più dadi con 4, 6, 8, 10, 12 o 20 facce e vedi ogni risultato più il totale. Ideale per giochi e giochi di ruolo da tavolo.`)
};

const pt_br2_dice_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rolador de dados online gratuito. Role um ou vários dados com 4, 6, 8, 10, 12 ou 20 lados e veja cada resultado além do total. Ótimo para jogos e RPGs de mesa.`)
};

const pt_dice_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lançador de dados online gratuito. Lance um ou vários dados com 4, 6, 8, 10, 12 ou 20 faces e veja cada resultado mais o total. Ótimo para jogos e RPGs de mesa.`)
};

const ja_dice_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンラインサイコロ。4面、6面、8面、10面、12面、20面のサイコロを1個または複数振り、各結果と合計を表示します。ゲームやテーブルトークRPGに最適。`)
};

const zh_dice_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线骰子生成器。掷出一个或多个 4、6、8、10、12 或 20 面骰子，查看每个结果及总和。适合游戏和桌面角色扮演。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dice_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dice_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dice_meta_description", locale)
	if (locale === "en") return en_dice_meta_description(inputs)
	if (locale === "es") return es_dice_meta_description(inputs)
	if (locale === "de") return de_dice_meta_description(inputs)
	if (locale === "nl") return nl_dice_meta_description(inputs)
	if (locale === "fr") return fr_dice_meta_description(inputs)
	if (locale === "it") return it_dice_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_dice_meta_description(inputs)
	if (locale === "pt") return pt_dice_meta_description(inputs)
	if (locale === "ja") return ja_dice_meta_description(inputs)
	return zh_dice_meta_description(inputs)
};